import { SearchResults } from '@forgerock/backstage-ui-core';
import { CommunityPost } from './community-post';
import { EntityType, Group, MediaType, Source } from './search-constants';

export interface EverythingSearchResult {
  canonicalTags: string[];
  categoryName: string;
  chapterName: string;
  community: string;
  creationTimestamp: string;
  entityType: EntityType | string;
  externalId: string;
  family: string;
  familyId: string;
  group: Group;
  id: string;
  isDownloadMeta: boolean;
  learningPathName: string;
  learningPathId: string;
  library: string;
  mediaType: MediaType | string;
  path: string;
  posts: CommunityPost[];
  priority: string;
  product: string;
  productVersionPaths: string[];
  productId: string;
  project: string;
  publicationType: string;
  segments: string[][];
  slug: string;
  snippet: string;
  source: Source;
  status: string;
  synopsis: string;
  tags: string[];
  thumbnailUrl: string;
  title: string;
  updateTimestamp: string;
  url: string;
  userId: string;
  version: string;
  bookId: string;
}

export interface EverythingSearchResultContainer<T = EverythingSearchResult> extends SearchResults<T> {
  aggregations: AggregationResultContainer[];
}

export interface AggregationResultContainer {
  name: keyof EverythingSearchResult;
  results: AggregationResult[];
}

export interface AggregationResult {
  value: string;
  total: number;
  topHits?: EverythingSearchResult[];
}

export function isEverythingSearchResult(obj: any): obj is EverythingSearchResult {
  return !!obj?.title;
}
